export const FILIAL = 'FILIAL';